<template>
	<div>
		<div class="form-group" :class="{'has-error': hasError}" v-if="!inline">
			<label v-if="label" :for="name" class="col-sm-4 col-md-3 control-label">{{ label }}</label>

			<div class="{{ class }}">
				<select v-if="select2" :name="name" :id="name" class="form-control" class="select2" :tags="tags" :options="options" v-model="vmodel" v-select="vmodel">
					<option v-for="option in options" track-by="$index" :value="option.value">{{ option.name }}</option>
				</select>

				<select v-else :name="name" :id="name" class="form-control" v-model="vmodel">
					<option v-for="option in options" track-by="$index" :value="option.value">{{ option.name }}</option>
				</select>

				<span v-if="hasError" class="help-block"><i class="fa fa-exclamation-triangle"></i> {{ errorMessage }}</span>
			</div>
		</div>
		<div v-else>
			<label v-if="label" :for="name">{{ label }}</label>

			<select v-if="select2" :name="name" :id="name" class="form-control" class="select2" :tags="tags" :options="options" v-model="vmodel" v-select="vmodel">
				<option v-for="option in options" track-by="$index" :value="option.value">{{ option.name }}</option>
			</select>

			<select v-else :name="name" :id="name" class="form-control" v-model="vmodel">
				<option v-for="option in options" track-by="$index" :value="option.value">{{ option.name }}</option>
			</select>
		</div>
	</div>
</template>

<script>
	import props from './props'
	import events from './events'

	export default {
		props,
		events,

		data() {
			return {
				hasError: false,
				errorMessage: null
			}
		},

		ready() {}
	}
</script>

<style scoped>
	.input-group {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// input-select.vue?e76ae1a0